import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import API from "./config/API";
import { jwtDecode } from "jwt-decode";

function TokenWatcher() {
  const navigate = useNavigate();

  const warningTimer = useRef(null);
  const logoutTimer = useRef(null);

  const [showPopup, setShowPopup] = useState(false);
  const [countDown, setCountDown] = useState(30);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user?.jwtToken) {
      navigate("/", { replace: true });
      return;
    }

    try {
      const decoded = jwtDecode(user.jwtToken);

      // Remaining milliseconds until expiry
      const remainingTime = decoded.exp * 1000 - Date.now();

      if (remainingTime <= 0) {
        logoutUser();
        return;
      }

      startSessionTimer(remainingTime);
    } catch (e) {
      logoutUser();
    }

    return () => {
      clearTimers();
    };
  }, []);
  /**
   * Start JWT Timer
   */
  const startSessionTimer = (expiresIn) => {
    clearTimers();

    if (expiresIn <= 30000) {
      setShowPopup(true);
      startCountDown(Math.floor(expiresIn / 1000));
      return;
    }

    warningTimer.current = setTimeout(() => {
      setShowPopup(true);
      startCountDown(30);
    }, expiresIn - 30000);
  };
  /**
   * Countdown starts from 30 sec
   */
  const startCountDown = (start) => {
    setCountDown(start);

    let seconds = start;

    logoutTimer.current = setInterval(() => {
      seconds--;

      setCountDown(seconds);

      if (seconds <= 0) {
        clearInterval(logoutTimer.current);
        logoutUser();
      }
    }, 1000);
  };
  /**
   * Continue Session
   */
  const continueSession = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      const response = await axios.post(
        `${API.V1}/pgOwner/refreshToken`,
        {
          userId: user.userId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user?.jwtToken}`,
          },
        },
      );

      const result = response.data;

      console.log("Refresh Response :", result);

      if (result.statusCode === 200) {
        user.jwtToken = result.data.jwtToken;
        user.expiresIn = result.data.expiresIn;

        localStorage.setItem("user", JSON.stringify(user));

        setShowPopup(false);

        clearTimers();

        const decoded = jwtDecode(result.data.jwtToken);

        const remaining = decoded.exp * 1000 - Date.now();

        startSessionTimer(remaining);
        alert("Session Extended Successfully");
      } else {
        alert(result.message);

        logoutUser();
      }
    } catch (error) {
      console.error(error);

      logoutUser();
    }
  };
  /**
   * Logout API
   */
  const logoutUser = async () => {
    try {
      const user = JSON.parse(localStorage.getItem("user"));

      if (user && user.userId) {
        const response = await axios.post(
          `${API.V1}/pgOwner/logout`,
          {
            userId: user.userId,
          },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user?.jwtToken}`,
            },
          },
        );

        console.log("Logout Response :", response.data);
      }
    } catch (error) {
      console.error("Logout Error :", error);
    } finally {
      clearTimers();

      localStorage.clear();
      sessionStorage.clear();

      setShowPopup(false);
      window.history.pushState(null, "", "/");

      navigate("/", {
        replace: true,
      });
      window.location.reload();
    }
  };

  /**
   * Clear Timers
   */
  const clearTimers = () => {
    if (warningTimer.current) {
      clearTimeout(warningTimer.current);
      warningTimer.current = null;
    }

    if (logoutTimer.current) {
      clearInterval(logoutTimer.current);
      logoutTimer.current = null;
    }
  };
  return (
    <>
      {showPopup && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <div style={styles.icon}>⏳</div>

            <h2 style={styles.title}>Session Expiring</h2>

            <p style={styles.message}>Your session will expire in</p>

            <div style={styles.countdown}>{countDown}</div>

            <p style={styles.message}>seconds.</p>

            <p style={styles.subMessage}>
              Click <b>Continue Session</b> to stay logged in, otherwise you'll
              be logged out automatically.
            </p>

            <div style={styles.buttonContainer}>
              <button style={styles.continueBtn} onClick={continueSession}>
                Continue Session
              </button>

              <button style={styles.logoutBtn} onClick={logoutUser}>
                Logout Now
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default TokenWatcher;
const styles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.55)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 99999,
    backdropFilter: "blur(3px)",
  },

  modal: {
    width: "430px",
    background: "#fff",
    borderRadius: "18px",
    padding: "35px",
    textAlign: "center",
    boxShadow: "0 20px 50px rgba(0,0,0,.35)",
    animation: "popup .35s ease",
  },

  icon: {
    fontSize: "60px",
    marginBottom: "15px",
  },

  title: {
    margin: 0,
    color: "#1e293b",
    fontSize: "28px",
    fontWeight: "700",
  },

  message: {
    color: "#475569",
    fontSize: "18px",
    marginTop: "15px",
    marginBottom: "10px",
  },

  countdown: {
    width: "90px",
    height: "90px",
    margin: "20px auto",
    borderRadius: "50%",
    background: "#dc2626",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "36px",
    fontWeight: "bold",
    boxShadow: "0 8px 20px rgba(220,38,38,.35)",
  },

  subMessage: {
    marginTop: "15px",
    color: "#64748b",
    fontSize: "15px",
    lineHeight: "24px",
  },

  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    gap: "15px",
    marginTop: "30px",
  },

  continueBtn: {
    flex: 1,
    background: "#2563eb",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "14px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    transition: "0.3s",
  },

  logoutBtn: {
    flex: 1,
    background: "#dc2626",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    padding: "14px",
    cursor: "pointer",
    fontSize: "16px",
    fontWeight: "bold",
    transition: "0.3s",
  },
};
